import { Box } from '@mui/material';
import { pageFrameStyle } from './PageFrame';

const PageLayout = ({
  children,
  centerContent = false,
  paddingTop = { xs: '30px', lg: '50px' },
  paddingBottom = { xs: '32px', lg: '40px' },
}) => (
  <Box component="main" sx={{ width: '100%' }}>
    <div className="pp-page-frame" style={pageFrameStyle}>
      <Box
        sx={{
          pt: paddingTop,
          pb: paddingBottom,
          ...(centerContent && { display: 'flex', flexDirection: 'column', alignItems: 'center' }),
        }}
      >
        {children}
      </Box>
    </div>
  </Box>
);

export default PageLayout;
